import api from '../../tools/api-tools'
import resUrl from './resource-url'
import qs from 'qs'
import event from '../../tools/event'
// import './index.mock'
import device from '../../tools/device'
import {AppStore} from './apple-store'
import {iosPay, wechatPay, alipay, canSelectPay} from './pay-bridge'
import route from '../../router'
import store from '../../store'
import wejs from 'weui.js'
import GoodsModel from '../goods'
import ValueAddedService from '../value-added-service'

const HARD_WARE_TYPE = 2
const SAAS_TYPE = 1

class Pay {
  constructor () {
    this.orderNo = ''
    this.goodsId = 0
    this.payStateMachine = {
      paying: false,
      isPaying () {
        return this.paying
      },
      startPay () {
        this.paying = true
      },
      finishPay () {
        this.paying = false
      }
    }
    this.enumObj = {
      wechatPay: 8,
      alipay: 2
    }
  }

  // 支付对象
  payObj ({goodsId, goodsType, quantity, couponCode = '', commuteIntegral = 0, remark = '', paytype = this.enumObj.wechatPay, orderId = 0, repay = 0}) {
    return {
      GoodsId: goodsId,
      GoodsType: goodsType,
      quantity: quantity,
      paytype: paytype,
      couponcode: couponCode,
      commuteIntegral: commuteIntegral,
      bankid: '',
      invoice: 0,
      remark: remark,
      source: this.sourceProcess(),
      appKey: device.ios ? 'iPhone2017DSbGEGoX' : 'AndroidNewAbpWozKy',
      orderId: orderId,
      repay: repay
    }
  }

  // 支付结果判断
  payResultProcess (payType) {
    payType = String(payType).toLowerCase()
    let payResult = {
      // IOS 内购
      'purchasesuccess': true,
      'purchasefailed': false,
      // wechat 支付
      '_wechat_pay_success_': true,
      '_wechat_pay_test_': true,
      '_wechat_pay_cancel_': false,
      '_wechat_pay_error_': false,
      // 硬件购买情况
      '0': true,
      '-2': false,
      '-1': false
    }
    console.log('payResult', payResult[payType])
    return payResult[payType] || false
  }

  // 通知客户端刷新账户
  noticeClientFresh () {
    let needNoticeGoodsIDs = [GoodsModel.saas.advanced.id]
    if (!device.android) return
    if (!needNoticeGoodsIDs.includes(this.goodsId)) return
    try {
      $fe_bridge.account.refresh() // eslint-disable-line
    } catch (e) {
    }
  }

  async payStatus (price, success = true) {
    this.payStateMachine.finishPay()
    let nowPath = route.app.$route.path
    let payStatusPath = 'paystatus'
    let finalPath = nowPath === '/' ? `${nowPath}${payStatusPath}` : `${nowPath}/${payStatusPath}`
    // 支付成功通知客户端刷新并发出支付成功事件
    if (success) {
      event.paySuccess.emit()
      this.noticeClientFresh()
    }
    console.log('goodsId', this.goodsId)
    store.dispatch('setPayStatus', {
      price: price,
      status: success ? 'success' : 'fail',
      orderNo: this.orderNo,
      goodsId: this.goodsId
    })
    // 为了解决IOS审核，在这里进行判断如果是：本地版本号>=cloud版本号,直接弹窗，不进行跳转失败面
    let version = await this._getReleaseVersion()
    if (!success && device.ios && (window.localStorage && (window.localStorage.getItem('version').toString() >= version.toString()))) {
      wejs.alert('支付失败,请重新支付！')
    } else {
      route.app.$router.push({path: finalPath})
    }
  }

  sourceProcess () {
    return device.ios ? 'ios_onlinemall' : 'android_onlinemall'
  }

  // 第三方支付统一处理流程
  // wechatPayProcess (order) {
  appPayProcess (order, basePayProcess) {
    let data = order.data
    let dataStringType = JSON.stringify(data)
    this.orderNo = data.orderNo || order.headers['mobileorderno'] // headers中的key是小写，设置orderNo，支付结果页面查询最终支付价格
    basePayProcess(dataStringType).then(result => {
      this.payStateMachine.finishPay()
      if (typeof result !== 'object') {
        try {
          result = decodeURIComponent(result)
          result = JSON.parse(result)
        } catch (e) {
          console.log(e)
          console.log(e.message)
        }
      }
      if (typeof result === 'string' && result === 'Uninstall') {
        return wejs.alert('尚未安装微信客户端')
      }
      if (typeof result === 'string' && result === 'Failed') {
        return wejs.alert('支付环境验证失败')
      }
      this.payStatus('', this.payResultProcess(result.code || result.type))
    }).catch(e => {
      this.payStateMachine.finishPay()
      console.log(e)
      console.log(e.message)
    })
  }

  // ios内购统一处理流程
  iosPayProcess (goodsId, quantity) {
    if (this.payStateMachine.isPaying()) return
    this.goodsId = parseInt(goodsId)
    let payIosObj = AppStore(goodsId, quantity)
    let orderModel = {
      MobileBusId: payIosObj.id,
      InvoiceAddressee: '',
      InvoiceDesc: '',
      InvoiceName: '',
      CouponCode: '',
      InvoicePhone: '',
      InvoiceAdress: '',
      PayType: 0,
      PayBankId: '',
      InvoiceVal: 0,
      source: this.sourceProcess()
    }
    this.payStateMachine.startPay()
    iosPay(orderModel, payIosObj).then(({result, price}) => {
      this.payStatus(price, this.payResultProcess(result))
    }).catch(({price}) => {
      this.payStatus(price, false)
    })
  }

  _selectPay (payObj) {
    // TODO 检查是否需要启动支付选择
    // if (device.ios) return wechatPay
    return canSelectPay().then(payTypeList => {
      // 默认使用微信支付
      if (payTypeList && payTypeList.length === 0) return wechatPay
      return store.dispatch('openPaySelector').then(res => {
        if (res === 'alipay') payObj.paytype = this.enumObj.alipay
        return {
          wechatPay: wechatPay,
          alipay: alipay,
          cancel: null
        }[res]
      })
    })
  }

  // 标准化订单创建
  async createOrder (payObj) {
    const basePayProcess = await this._selectPay(payObj)
    if (!basePayProcess) return
    // 检查订单工作状态，一个订单没有完成
    if (this.payStateMachine.isPaying()) return
    this.goodsId = parseInt(payObj.GoodsId)
    this.payStateMachine.startPay()
    api.post(resUrl.index + '?' + qs.stringify(payObj)).then(res => {
      // 订单创建成功回调
      event.createOrderSuccessHook.emit()
      if (!this._continueWithoutError()) return
      if (this._freeOrder(res)) return // 处理0元订单
      this.appPayProcess(res, basePayProcess)
    }).catch(e => {
      this.payStateMachine.finishPay()
    })
  }

  _continueWithoutError (data) {
    // 判断当前返回值是否有错误，return true 代表继续执行
    if (typeof data !== 'string') return true

    function someError () {
      // alipay 用来判断是不是Alipay，SUCCESS 用来判断0元订单
      return data.indexOf('alipay') === -1 && data !== 'SUCCESS'
    }

    if (typeof data === 'string' && someError()) {
      this.payStateMachine.finishPay() // 支付状态机完成支付
      return false
    }
    return true
  }

  // 0元体验处理流程
  _freeOrder (order) {
    if (order.data === 'SUCCESS') {
      this.payStateMachine.finishPay() // 支付状态机完成支付
      this.payStatus(0) // 响应0元支付成功界面
      return true
    }
    return false
  }

  // 购买服务
  async saasPay (goodsId, quantity) {
    if (device.ios && await this._onlyUseWechatPay(goodsId)) {
      console.log('iosPayProcess')
      this.iosPayProcess(goodsId, quantity)
    } else {
      console.log('thirdPartyPay')
      this.thirdPartyPay(goodsId, quantity)
    }
  }

  // 第三方支付
  thirdPartyPay (goodsId, quantity) {
    let payObj = this.payObj({goodsId, goodsType: SAAS_TYPE, quantity})
    this.createOrder(payObj)
  }

  // 返回false，使用微信支付
  async _onlyUseWechatPay (goodsId) {
    // 如果是一年高级版本，直接订阅内购
    if (goodsId === GoodsModel.saas.advanced.id) return true
    // 如果是行业版本（服装、鞋帽、数码）之一
    if ([GoodsModel.saas.professionClothing.id, GoodsModel.saas.professionBarber.id, GoodsModel.saas.profession3C.id].includes(goodsId)) {
      let version = window.localStorage.getItem('version') || 0
      let UCloudVersion = await new ValueAddedService().getReleaseVersion()
      // 如果本地版本 >= UCloundVersion 走内购 (为避开苹果审核)
      if (version >= UCloudVersion) {
        return true
      }
    }
    return false
    // if (window.localStorage && window.localStorage.getItem('version') === '3.1.4') return false
    // return ![GoodsModel.saas.groupPackage.id, GoodsModel.saas.mobilePay.id, GoodsModel.saas.wxCardAdvanced.id, GoodsModel.saas.miniApp.id, GoodsModel.saas.newRetail.id, GoodsModel.saas.shopWindow.id, GoodsModel.saas.wechatCard.id, GoodsModel.saas.msgActivity.id, GoodsModel.saas.smsActivity.id, GoodsModel.saas.wxCardSuite.id, GoodsModel.saas.advPermanent.id, GoodsModel.saas.proPermanent.id, GoodsModel.saas.wxCardSuiteOneYear.id, GoodsModel.saas.advPermanentLifelong.id, GoodsModel.saas.proPermanentLifelong.id].includes(Number(goodsId))
  }
  // 充值
  rechargePay (goodsId, targetNum = '') {
    let payObj = this.payObj({goodsId, quantity: 1, goodsType: SAAS_TYPE, remark: targetNum})
    this.createOrder(payObj)
  }

  // 购买硬件
  hardwarePay (goodsId, quantity, couponCode = '', commuteIntegral = 0, remark = '') {
    let payObj = this.payObj({goodsId, goodsType: HARD_WARE_TYPE, quantity, couponCode, commuteIntegral, remark})
    this.createOrder(payObj)
  }

  // 重新支付
  rePay (orderId) {
    this.createOrder(this.payObj({orderId, repay: 1}))
  }

  // Saas续费，仅使用微信支付
  rechargeSaas (goodsId, quantity) {
    let payObj = this.payObj({goodsId, goodsType: SAAS_TYPE, quantity})
    delete payObj.source
    this.createOrder(payObj)
  }

  /**
   * 新版本续费方法
   * @param {Number} goodsId 商品ID
   * @param {Number} quantity 商品数量 默认为 12
   * @param {Number} payType 支持方式 8 微信  2 支付宝
   * @author 张晓东
   * @Date 2019-06-24
   */
  renewalSass (goodsId, payType, quantity = 12) {
    let payObj = this.payObj({goodsId: goodsId, goodsType: SAAS_TYPE, paytype: payType, quantity})
    // 单独创建订单流程，因为这里不用弹出支付方式选择
    // 检查订单工作状态，一个订单没有完成
    let basePayProcess = wechatPay
    if (payType === 2) basePayProcess = alipay
    if (this.payStateMachine.isPaying()) return
    this.goodsId = parseInt(payObj.GoodsId)
    this.payStateMachine.startPay()
    api.post(resUrl.index + '?' + qs.stringify(payObj)).then(res => {
      // 订单创建成功回调
      event.createOrderSuccessHook.emit()
      if (!this._continueWithoutError()) return
      if (this._freeOrder(res)) return // 处理0元订单
      this.appPayProcess(res, basePayProcess)
    }).catch(e => {
      this.payStateMachine.finishPay()
    })
  }

  // 获取Cloud返回的版本号
  _getReleaseVersion () {
    return api.get(`http://cloud.fe.laoban100.com/cloud/5a8e6af24710cdd4b0399201/ios/version/beforeRelease`).then(res => {
      return res.data.version || ''
    })
  }
}

export default Pay



// WEBPACK FOOTER //
// ./src/model/pay/index.js